// primeprivatenetwork
export  const BASE_URL ='https://primeprivatenetwork.com';



// Global India RealEstate
export  const BASE_URL_GIRE ='https://api.globalindiarealestate.com/ws';

